import { MDBAutocomplete, MDBBtn, MDBIcon, MDBSpinner } from "mdb-react-ui-kit";
import React, { memo, useEffect, useState } from "react";
import { getHuntsgroups } from "../../apiclients/streamsapi_bridge";
import CFNodeUI from "./NodeUI";
import DropDown from "./DropDown";
export default memo(({ data, isConnectable, id }) => {
  const [isloading, setIsloading] = useState(true);
  const [selected, setSelected] = useState(
    data.selected_object ? data.selected_object.label : ""
  );
  const [huntgroups, setHuntgroups] = useState([]);
  function onDelete(id) {
    data.onDelete(id);
  }
  async function fetchHGroupData() {
    let data = [];
    try {
      const response = await getHuntsgroups(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      const rawData = await response.json();
      if (response.status === 200) {
        data = rawData?.groups ?? [];
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
    }
    console.log("Loaaaaaddddddddded ....");
    let tadIndex = data.filter((titem) => titem.tittle === "Create New").length;
    console.log(tadIndex);
    if (tadIndex === 0) {
      setHuntgroups([{ _id: -1, title: "Create New" }, ...data]);
    }

    setIsloading(false);
  }

  useEffect(() => {
    fetchHGroupData();
    data.actionExecutor({ action: -1 });
  }, []);
  useEffect(() => {
    setSelected(data.selected_object ? data.selected_object.label : "");
  }, [data.selected_object]);

  const [customData, setCustomData] = useState(huntgroups);
  const onCustomSearch = (value) =>
    setCustomData(
      huntgroups.filter(
        (item) =>
          item.title.toLowerCase().startsWith(value.toLowerCase()) ||
          (item.extensions &&
            item.extensions.toString().startsWith(value.toLowerCase()))
      )
    );

const windowsMap = {};
const openLocation = (e) => {
  if (localStorage.getItem("s_message")) {
    console.log("Removing s_message...");
    localStorage.removeItem("s_message");
  } else {
    console.log("s_message does not exist in localStorage.");
  }

  e.preventDefault();
  e.stopPropagation();

  localStorage.setItem("selectedItem", data.selected_object.code);
  localStorage.setItem("huntGrpInfo", JSON.stringify(data.selected_object.code));

  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const width = screenWidth * 0.8;
  const height = screenHeight * 0.8;
  const left = (screenWidth - width) / 2;
  const top = (screenHeight - height) / 2;

  const windowFeatures = `width=${width},height=${height},top=${top},left=${left}`;
  const windowName = `callflowHuntNode`;

  if (windowsMap[windowName] && !windowsMap[windowName].closed) {
    // Focus and reload the existing window
    windowsMap[windowName].focus();
    windowsMap[windowName].location.reload();
  } else {
    // Open a new window and store the reference
    const huntWindow = window.open("/huntaccinfo", "", windowFeatures);
    windowsMap[windowName] = huntWindow;

    // Setup communication from child to parent
    window.receiveMessageFromHuntChild = (nodeFlag) => {
      if (nodeFlag === 1) {
        data.actionExecutor({ action: 17, value: "Hunt group" });
        console.log("Received message from child:", nodeFlag);
      }
    };
  }
};


  const autoFocus = (event) => {
    if (event.target.value != "") {
      event.target.select();
      setCustomData(huntgroups);
    }
  };
  const deleteHandle = (h, hs) => {
    data.actionExecutor({ action: 2, value: { h }, handles: hs });
  };

  useEffect(() => {
    if (!Array.isArray(data.handles) || data.handles.length === 0) {
      data.handles = [{ name: "Busy/No Answer" }];
    }
    data.actionExecutor({ action: 0 });
  }, [huntgroups]);

  function setTSelected(value) {
    if (value === "Create New" && data.selected_object) {
      setSelected(data.selected_object.label);
      return;
    }
    console.log(value);
    setSelected(value);
    if (!data.selected_object) {
      data.selected_object = {};
    }
    data.selected_object.label = value;
  }

  const addItem = (newItem) => {
    console.log(
      "---------------------------------333333333333333333333333333333"
    );
    console.log(newItem);
    console.log(huntgroups);
    if (newItem && newItem.isnew === 1) {
      if (!huntgroups.some((item) => item.title === newItem.label)) {
        console.log(newItem);
        console.log("includijng Item");
        if (newItem && newItem.label != "Create New") {
          if (newItem.label) newItem.title = newItem.label;
          setSelected(newItem.label);
          setHuntgroups([
            ...huntgroups.slice(0, 1),
            newItem,
            ...huntgroups.slice(1),
          ]);
        }
      }
    }
  };

  function processClick(value) {
    if (value === " Create New") {
      data.actionExecutor({ action: 1 });
    } else {
      let tGrp = huntgroups.filter(
        (grp) => grp.title === value.split(" : ")[1]
      )[0];
      data.selected_object_old = data.selected_object ? data.selected_object : { ...tGrp, label: tGrp.title };
      data.selected_object = { ...tGrp, label: tGrp.title };
      data.actionExecutor({
        action: 3,
        value: tGrp || -1,
      });
      data.actionExecutor({
        action: 2,
        value: tGrp || -1,
      });
      data.actionExecutor({
        action: 7,
        value: tGrp || -1,
      });
    }
  }
  useEffect(() => {
    addItem(data.selected_object);
  }, [data.selected_object]);
  return (
    <>
      <CFNodeUI
        headerClass="huntNodeHeader"
        data={data}
        targethandles={data.handles}
        deletable={true}
        onDelete={onDelete}
        onHandleDelete={deleteHandle}
        bodyContnent={
          <>
            <DropDown
              data={huntgroups}
              nodedata={data}
              onLinkClick={openLocation}
              onSelect={processClick}
              disp={(item) => {
                const categoryPart = item.category ? ` : ${item.category}` : "";
                const extensionpart = item.extensions
                  ? `${item.extensions} :`
                  : "";
                return `${extensionpart} ${item.title}${categoryPart}`;
              }}
              title={
                data.selected_object
                  ? data.selected_object.title
                  : "Choose Hunt"
              }
              showhyperlink={!!data.selected_object}
            ></DropDown>
          </>
        }
        targetNode={true}
      />
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
});
